import { Button, Card, CardContent, Grid } from "@mui/material";
import { ConfirmDangerModalComponent, IDType, TaxType } from "@soqs/common";
import {
  formState,
  updateFormState,
  currentPage,
  setPage,
  submitFormAsync,
  isLoading,
} from "../features/AppSlice";
import React, { useMemo, useState } from "react";
import { Form, FormSpy } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import createDecorator from "final-form-calculate";
import EnterALookupDetails from "./EnterDetailsComponents/EnterALookupDetails";
import AssessmentResult from "./EnterDetailsComponents/AssessmentResult";

const EnterDetails = () => {
  const loading = useSelector(isLoading);
  const dispatch = useDispatch();
  const wizardPage = useSelector(currentPage);
  const setWizardPage = (newPage) => {
    dispatch(setPage(newPage));
  };
  const [confirmClearModal, setConfirmClearModal] = useState(false);

  const getInitials = (name) => {
    if (!name) {
      return undefined;
    }
    return name
      .split(" ")
      .filter((x) => x !== "")
      .reduce((acc, curr) => {
        return acc + curr[0];
      }, "")
      .toUpperCase()
      .slice(0, 4);
  };

  const setInitials = useMemo(
    () =>
      createDecorator({
        field: "name",
        updates: {
          initials: (name, allValues, prevValues) => {
            //Lockout update when initials does not match name any more
            if (
              prevValues &&
              getInitials(prevValues.name) === prevValues.initials
            ) {
              return getInitials(name);
            } else {
              return allValues.initials;
            }
          },
        },
      }),
    []
  );

  const initV = {
    taxtype: TaxType.PIT,
    idtype: IDType.RSA_Id,
    methodindex: 1,

    // idnumber: "6305110073084",
    // title: "Mr",
    // surname: "Test Surname",
    // name: "Test Name",
    // initials: "TN",
    // taxnumber: "1474362645",
  };
  const reduxFormState = useSelector(formState);
  const prefilledState = useMemo(() => reduxFormState?.values ?? initV, []);

  return (
    <Form
      onSubmit={async () => {
        switch (wizardPage) {
          case 0: {
            dispatch(submitFormAsync());
            break;
          }

          default: {
            setWizardPage(wizardPage + 1);
          }
        }
      }}
      decorators={[setInitials]}
      initialValues={prefilledState}
    >
      {({ handleSubmit, submitting, values, form }) => (
        <>
          <Grid container spacing={2} direction="column">
            <FormSpy
              onChange={(state) => {
                dispatch(updateFormState(state));
              }}
            />
            <Wizard page={wizardPage} />
            {wizardPage == 2 ? null : (
              <Grid size={{ xs: 12 }}>
                <Card>
                  <CardContent>
                    <Grid
                      container
                      spacing={2}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            if (wizardPage == 0) {
                              setConfirmClearModal(true);
                            } else {
                              setWizardPage(wizardPage - 1);
                            }
                          }}
                        >
                          {wizardPage == 0 ? "Reset Form" : "Back"}
                        </Button>
                      </Grid>

                      <Grid>
                        {window.REACT_APP_CONFIG.ENVIRONMENT ===
                          "development" ||
                        window.REACT_APP_CONFIG.ENVIRONMENT === "qadebug" ? (
                          <Button
                            id="continue-to-upload"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              dispatch(submitFormAsync());
                            }}
                            loading={submitting}
                          >
                            Continue (No FE validation)
                          </Button>
                        ) : null}

                        <Button
                          id="continue-to-upload"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          loading={loading}
                          type="submit"
                        >
                          Continue
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            )}
          </Grid>

          <ConfirmDangerModalComponent
            open={confirmClearModal}
            onClose={() => {
              setConfirmClearModal(false);
            }}
            cbConfirm={() => {
              form.restart(initV);
              setConfirmClearModal(false);
            }}
            title="Reset form"
            subheader="Are you sure you want to clear the form?"
            confirmText="Clear"
          />
          {window.REACT_APP_CONFIG.ENVIRONMENT === "development" ? (
            <pre>{JSON.stringify(values, null, 2)}</pre>
          ) : (
            <></>
          )}
        </>
      )}
    </Form>
  );
};
const Wizard = ({ page }) => {
  switch (page) {
    case 0: {
      return <EnterALookupDetails />;
    }
    case 2: {
      return <AssessmentResult />;
    }

    default:
      return <></>;
  }
};
export default EnterDetails;
